import PageTitle from '@components/PageTitle'
import WithPortalAuthorization from '@hocs/WithPortalAuthorization'
import InstructorAvailability from '@layouts/InstructorAvailability'
import React from 'react'

const MIDashboard: React.FC = () => (
  <>
    <PageTitle title={'MI dashboard'} />
    <InstructorAvailability />
  </>
)

export default WithPortalAuthorization(MIDashboard, {
  id: 'page::dashboard::mi',
  queryParams: ['ie'],
})
